import { render, staticRenderFns } from "./InvoiceRecord.vue?vue&type=template&id=62cd7955"
import script from "./InvoiceRecord.vue?vue&type=script&lang=js"
export * from "./InvoiceRecord.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRecord.vue?vue&type=style&index=0&id=62cd7955&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports